export interface FastTrackGradeResult {
  percentage: number;
  passed: boolean;
  letterGrade: string;
  n: string;
}

const FAST_TRACK_BRACKETS = [
  { grade: 'A+', range: 97, n: true },
  { grade: 'A', range: 93, n: true },
  { grade: 'A-', range: 90, n: true },
  { grade: 'B+', range: 87 },
  { grade: 'B', range: 83 },
  { grade: 'B-', range: 80 },
  { grade: 'C+', range: 77 },
  { grade: 'C', range: 73 },
  { grade: 'C-', range: 70 },
  { grade: 'D+', range: 67 },
  { grade: 'D', range: 63 },
  { grade: 'D-', range: 60 },
  { grade: 'F', range: 0, n: true },
];

export function calculateGrade(correctAnswers: string[], totalQuestions: number): FastTrackGradeResult {
  const uniqueCorrect = [...new Set(correctAnswers)];
  const rawPercentage = totalQuestions > 0 ? (uniqueCorrect.length / totalQuestions) * 100 : 0;
  const percentage = Math.floor(rawPercentage);
  const bracket = FAST_TRACK_BRACKETS.find(({ range }) => rawPercentage >= range) ?? FAST_TRACK_BRACKETS[FAST_TRACK_BRACKETS.length - 1];
  const passed = bracket.range > 0;
  return { percentage, passed, letterGrade: bracket.grade, n: bracket.n === true ? 'n' : '' };
}
